<div class="analytics-wrapper">
    <iframe title="Report Section" width="600" height="373.5"
        [src]="iframeData.iframe | safe"
        frameborder="0" allowFullScreen="true"></iframe>
        <!-- <iframe title="Report Section" width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiZTFmMjhmNGEtMDAwMS00Nzg0LWExZTYtN2YzYTVmMjgwNTU5IiwidCI6ImU3MTI1Y2IzLTEzNDUtNGRhZS05ODM2LWJlMTBkNzExMTdkZCJ9&pageName=ReportSection20411d8ff4a26aa89fe4" frameborder="0" allowFullScreen="true"></iframe> -->

    <div class="microsoft-overlay"></div>
    <div class="social-icons-overlay"></div>
</div>
